import {
  TIPTAP_ACTION_BUTTON_TYPE,
  TIPTAP_FIGURE_TYPE,
  TIPTAP_LINK_BUTTON_TYPE
} from "./../../ricos-content/index.js";
import { Node_Type } from "./../../ricos-schema/legacy/wix/rich_content/v1/index.js";
import { getContainerData } from "./../../_shared/node-styles.js";
import { PmNodeType } from "./../../_shared/pm-node-types.js";
const CLOSED_FOR_SPACING_TYPES = [
  TIPTAP_FIGURE_TYPE,
  TIPTAP_LINK_BUTTON_TYPE,
  TIPTAP_ACTION_BUTTON_TYPE,
  Node_Type.IMAGE,
  Node_Type.VIDEO,
  Node_Type.GALLERY,
  Node_Type.DIVIDER,
  Node_Type.HTML,
  Node_Type.EMBED,
  Node_Type.FILE,
  Node_Type.GIF,
  Node_Type.AUDIO,
  Node_Type.POLL,
  Node_Type.BUTTON,
  Node_Type.ORDERED_LIST,
  Node_Type.BULLETED_LIST,
  Node_Type.LIST_ITEM,
  Node_Type.LINK_PREVIEW,
  Node_Type.APP_EMBED,
  Node_Type.CODE_BLOCK,
  Node_Type.BLOCKQUOTE,
  Node_Type.TABLE,
  Node_Type.TABLE_CELL,
  Node_Type.LAYOUT,
  Node_Type.LAYOUT_CELL,
  Node_Type.COLLAPSIBLE_LIST,
  Node_Type.COLLAPSIBLE_ITEM_BODY,
  Node_Type.SHAPE
];
const isNodeSpaced = (nodeType) => CLOSED_FOR_SPACING_TYPES.includes(nodeType);
const NODES_WITH_TOP_OVERFLOW = [
  Node_Type.IMAGE,
  Node_Type.SHAPE,
  Node_Type.LAYOUT
];
const needsTopMargin = (nodeType) => nodeType ? NODES_WITH_TOP_OVERFLOW.includes(nodeType) : false;
const needsTopMarginForPmNode = (node) => {
  if (!node) return false;
  const nodeType = node.type.name;
  if (NODES_WITH_TOP_OVERFLOW.includes(nodeType)) {
    return true;
  }
  if (nodeType === TIPTAP_FIGURE_TYPE) {
    const firstChild = node.firstChild;
    return firstChild?.type.name === Node_Type.IMAGE;
  }
  return false;
};
const isCollapsedBetween = (firstNodeType, secondNodeType, parentNodeType, options) => {
  const isEdgeNode = !firstNodeType || !secondNodeType;
  if (isEdgeNode && parentNodeType !== Node_Type.LIST_ITEM) {
    return true;
  }
  if (options?.bothFullWidth) {
    return true;
  }
  return false;
};
const getNodeContainerData = (node) => {
  if ("attrs" in node && node.attrs) {
    if (node.type.name === PmNodeType.FIGURE) {
      return node.firstChild?.attrs?.containerData;
    }
    return node.attrs.containerData;
  }
  if ("type" in node && "id" in node) {
    return getContainerData(node);
  }
  return null;
};
const isNodeFloated = (node) => {
  if (!node) return false;
  const containerData = getNodeContainerData(node);
  const hasTextWrap = containerData?.textWrap ?? true;
  const isFloatableAlignment = containerData?.alignment === "LEFT" || containerData?.alignment === "RIGHT";
  return hasTextWrap && isFloatableAlignment;
};
const isBetweenFloatedNodes = (node1, node2) => isNodeFloated(node1) && isNodeFloated(node2);
const getNodeType = (node) => {
  if ("attrs" in node && node.type?.name) {
    if (node.type.name === PmNodeType.FIGURE) {
      return node.firstChild?.type.name || node.type.name;
    }
    return node.type.name;
  }
  if ("type" in node && "id" in node) {
    return node.type;
  }
  return "";
};
const isNodeFullWidth = (node) => {
  if (!node) return false;
  const nodeType = getNodeType(node);
  if (nodeType === Node_Type.LAYOUT) {
    return true;
  }
  const containerData = getNodeContainerData(node);
  return containerData?.width?.size === "FULL_WIDTH";
};
const isBetweenFullWidthNodes = (node1, node2) => isNodeFullWidth(node1) && isNodeFullWidth(node2);
export {
  isBetweenFloatedNodes,
  isBetweenFullWidthNodes,
  isCollapsedBetween,
  isNodeFloated,
  isNodeFullWidth,
  isNodeSpaced,
  needsTopMargin,
  needsTopMarginForPmNode
};
//# sourceMappingURL=gap-spacer-nodes.js.map
